import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from "../../Components/Sidebar/Sidebar";
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useClientUserState } from '../../Contexts/ClientUserStateContext';
import { useApi } from '../../Services/api';
import Popup from '../../Components/Popup/Popup';
import Buttons from '../../Components/Buttons/Buttons';
import { isMobile } from 'react-device-detect';
import './Dashboard.css';

// Importing components
import AccessInterpreter from '../AccessInterpreter/AccessInterpreter'
import Integrations from '../Integrations/Integrations'
import Invite from '../Invite/Invite'
import Transactions from '../Transactions/Transactions'
import AccountBilling from '../AccountDetails/AccountBilling/AccountBilling'
import AccountInformation from '../AccountDetails/AccountInformation/AccountInformation'

const Dashboard = ({selectedRoute}) => {
  const [selectedComponent, setSelectedComponent] = useState(selectedRoute);
  const [isTokenValid, setIsTokenValid] = useState(null);
  const [loadComponent, setLoadComponent] = useState(false); 
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const api = useApi();
  const { setClientUser } = useClientUserState();
  const { voyceToken, setErrorVisible, setNetworkErrorVisible, setVoyceToken } = useGlobalState();
  const navigate = useNavigate();

  // get user information
  useEffect(() => { 
    if (!voyceToken || isMobile) {
      setIsTokenValid(false);
      navigate('/Login');
      return;
    }
  
    const handleRoleCheck = (data) => {
      const isAdminRole = checkIfAdmin(data.Roles);
      if (isAdminRole) {
        setClientUser(prevState => ({ ...prevState, IsAdmin: true }));
      }
    };
  
    const checkIfAdmin = (roles) => {
      return roles.some(role => role.RoleName === "Admin");
    };
  
    const fetchUserInfo = async () => {
      try {
        const response = await api.get('Client/SelfSignUpClientUser');
        const data = response.data;
        setClientUser(data);
        setLoadComponent(true);
        handleRoleCheck(data);
      } catch (error) {
        handleFetchError(error);
      }
    };
  
    const handleFetchError = (error) => {
      clearInterval(intervalId);
      console.log('error:', error);
      
      if (error.code === "ERR_NETWORK") {
        setNetworkErrorVisible(true);
      } else if (error.response?.data?.Id === 2) {
        setErrorVisible(false);
        setShowLogoutPopup(true);
        clearInterval(intervalId);
      } else {
        setErrorVisible(false);
      }
    };
  
    setIsTokenValid(true);
    fetchUserInfo();
  
    // every 5 seconds ping
    const intervalId = setInterval(() => {
      fetchUserInfo();
    }, 5000);
  
    return () => clearInterval(intervalId);
  
  }, [voyceToken, isMobile]);
  
  


  const handleItemSelected = (eventKey) => {
    setSelectedComponent(eventKey);
  };


  useEffect(() => {
    if (!isTokenValid) {
      return;
    }
    if (selectedComponent) {
      if (selectedComponent === 'AccessInterpreter') {
        const currentPath = window.location.pathname.split('/')[0];
        const rootPath = window.location.origin;
        const newPath = rootPath + process.env.PUBLIC_URL + currentPath;
        window.history.pushState({}, '', newPath);
      } else {
        // get current path
        const currentPath = window.location.pathname.split('/')[0];
        const rootPath = window.location.origin;
        const newPath = rootPath + process.env.PUBLIC_URL + currentPath + '/' + selectedComponent;
        window.history.pushState({}, '', newPath);
      }
      
    }
  }, [isTokenValid, selectedComponent]);

  // render each
  const renderComponent = () => {
    if (loadComponent === false) {
      return null;
    }
    switch (selectedComponent) {
      case 'AccessInterpreter': {return <AccessInterpreter />;}
      case 'Integrations': {return <Integrations />;}
      case 'Invite': {return <Invite />;}
      case 'Transactions': {return <Transactions />;}
      case 'AccountInformation': {return <AccountInformation />;}
      case 'AccountBilling': {return <AccountBilling />;}
      default: return null;
    }
  };

  const handleLoginPage = () => {
    setVoyceToken(null);
    navigate('/Login');
  }
  
  // For first load
  if (isTokenValid === null) {
    return null;
  }
  return (
    <>
      <div className="dashboard-container">
        <div className="sidebar-wrapper">
          <Sidebar onDefault={selectedComponent} onItemSelected={handleItemSelected} />
        </div>
        <div className="page-content-wrapper">
          {renderComponent()}
        </div>
      </div>
      <Popup
          show={showLogoutPopup}
          handleClose={handleLoginPage}
          titleStyle="dashboard-popup-title"
          body={
            <>
              <div>You've been logged out as your account is active on another device/browser.</div>
              <div></div>
              <div>Please login again.</div>
            </>
            }
          bodyStyle="dashboard-popup-body"
          footer={
            <>
              <div className="paymentpage-success-btn">
                <Buttons handleSubmit={handleLoginPage} text={"Login"} CardElement='payment-element' /></div>
            </>
          }
          footerStyle="dashboard-popup-footer"
        />
    </>
  );
};

export default Dashboard;
